import type { FC } from 'react';

export const RichTextContent: FC<{ content: string } & React.HTMLAttributes<HTMLInputElement>> = ({ content, ...props }) => (
	<div {...props} className={'rsw-ce ' + (props.className ?? '')} dangerouslySetInnerHTML={{ __html: content }}></div>
);
